import React from 'react';
import { Navigate } from 'react-router-dom';
import { getEffectivePermissions } from '../utils/permissions';
import { isSettingsLookupOnlyNav } from '../utils/settingsLookupNavAccess';

/** Default child when opening /settings — lookup editors land on a referral lookup, admins on Staff. */
function SettingsIndexRedirect() {
  const perms = getEffectivePermissions();
  const to = isSettingsLookupOnlyNav(perms) ? 'insurance-companies' : 'staff';
  return <Navigate to={to} replace />;
}

export default SettingsIndexRedirect;
